module.exports = __webpack_public_path__ + "static/img/screen1.a094634.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screen1.png
// module id = rkxw
// module chunks = 36